var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('blockquote',[_c('h5',[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('Bareme.etape2.resultat.baremeDetermine')))]),_vm._v(" "+_vm._s(_vm.dossier.bareme)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }